@if (group) {
  <div class="group-content-wrapper"
       [ngClass]="{ expanded: !group.collapsed }"
  >
    <div class="group-wrapper ops-form">
      <div class="group">
        <button mat-icon-button
                (click)="toggleGroupExpansion()"
                [attr.aria-label]="(group.collapsed? 'expand ' : 'collapse ') + group.name"
        >
          @if (group.collapsed) {
            <mat-icon class="tree-level-button">arrow_right</mat-icon>
          } @else {
            <mat-icon class="tree-level-button">arrow_drop_down</mat-icon> <!-- expanded -->
          }
        </button>

        <div class="group-name">{{ group.name }}</div>
      </div>
    </div>

    @if (!group.collapsed) {
      <div class="items">
        @for (item of group.items; track $index) {
          <div class="item">
            <app-route-group-menu
              [path]="getPath()"
              [routeHierarchyItem]="item"
            ></app-route-group-menu>
          </div>
        }
      </div>
    }
  </div>
}

@if (item) {
  <app-action-menu-item
    [input]="item"
  ></app-action-menu-item>
}
